import { useState } from "react";
import { CheckIcon } from "assets/icons";
import { FoodCardList } from "components";
import PaymentProcessModal from "components/modals/PaymentProcessModal";

function Payment() {
  const paymentMethods = [
    {
      label: "Debit / Credit Card",
      value: "debit-credit",
    },
    {
      label: "FPX Online",
      value: "fpx-online",
    },
    {
      label: "E-Wallet",
      value: "e-wallet",
    },
  ];
  const [payWith, setPayWith] = useState(paymentMethods[0]);
  const [saveCardDetail, setSavedCardDetail] = useState(false);
  const [payNow, setPayNow] = useState(false);

  const addOnItems = [
    {
      label: "Paneer Tikka Rice Bowl - Mini",
      price: 40.0,
      image: "/images/food-1.png",
    },
  ];

  return (
    <>
      <div className="w-full gap-10 bg-white shadow-cityCard py-6 px-6">
        <div className="w-full flex flex-col-reverse lg:flex-row gap-10 mb-8 md:mb-10">
          <div className="flex-1">
            <div className="text-lg md:text-2xl font-semibold text-[#0A0D13] mb-6 md:mb-9">
              Payment
            </div>
            <div className="w-full flex flex-col mb-9">
              <div className="text-[#0A0D13] text-sm sm:text-base font-semibold mb-4">
                Pay With:
              </div>
              <div className="w-full flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
                {paymentMethods.map((item, index) => (
                  <label key={index} className="flex items-center gap-2">
                    <div
                      className={`h-[18px] min-w-[18px] p-[3px] rounded-full border-[1px] border-primary-700 animation cursor-pointer ${
                        payWith.value == item.value ? "border-primary-700" : ""
                      }`}
                      onClick={() => setPayWith(item)}
                    >
                      {payWith.value == item.value && (
                        <div className="h-full w-full bg-primary-700 rounded-full" />
                      )}
                    </div>

                    <div
                      className={`text-sm sm:text-base font-medium ${
                        payWith.value == item.value
                          ? "text-black"
                          : "text-[#ACACAC]"
                      }`}
                    >
                      {item.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>
            <div className="w-full sm:max-w-[200px] flex flex-col gap-4 mb-6">
              <div className="text-[#0A0D13] font-semibold text-sm sm:text-base">
                Card Number
              </div>
              <input
                type="text"
                placeholder="1234  5678  9101  1121"
                className="border-[1.5px] border-[#ACACAC] py-3 px-4 rounded-[4px]"
              />
            </div>
            <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
              <div className="w-full sm:max-w-[200px] flex flex-col gap-4">
                <div className="text-[#0A0D13] font-semibold text-sm sm:text-base">
                  Expiration Date
                </div>
                <input
                  type="text"
                  placeholder="MM/YY"
                  className="border-[1.5px] border-[#ACACAC] py-3 px-4 rounded-[4px]"
                />
              </div>
              <div className="w-full sm:max-w-[200px] flex flex-col gap-4">
                <div className="text-[#0A0D13] font-semibold text-sm sm:text-base">
                  CVV
                </div>
                <input
                  type="text"
                  placeholder="123"
                  className="border-[1.5px] border-[#ACACAC] py-3 px-4 rounded-[4px]"
                />
              </div>
            </div>
            <button
              className="flex items-center gap-3"
              onClick={() => setSavedCardDetail(!saveCardDetail)}
            >
              <div
                className={`h-4 w-4 border-[1.5px] rounded-[2px] flex items-center justify-center ${
                  saveCardDetail
                    ? "border-primary-700 bg-primary-700 text-white"
                    : "border-[#ACACAC]"
                }`}
              >
                {saveCardDetail && <CheckIcon />}
              </div>
              <div className="text-sm sm:text-base text-[#ACACAC] font-medium">
                Save card details
              </div>
            </button>
          </div>
          <div className="flex-1">
            <div className="text-lg md:text-2xl font-semibold text-[#0A0D13] mb-6 md:mb-9">
              Order Summary
            </div>
            <div className="flex flex-col gap-3 mb-9">
              {addOnItems.map((item, index) => (
                <FoodCardList key={index} data={item} />
              ))}
            </div>
            <div className="w-full flex items-center gap-4 mb-9">
              <input
                className="w-full h-[46px] rounded-[4px] border-[1.5px] border-[#ACACAC] px-4 text-sm sm:text-base text-[#ACACAC]"
                placeholder="Voucher Code"
              />
              <button className="min-w-[128px] h-[46px] rounded-[4px] bg-[#ACACAC] text-[#F3F3F3]">
                Apply
              </button>
            </div>
            <div className="w-full py-6 flex flex-col gap-4 border-t-[1px] border-b-[1px] border-[#ACACAC] mb-6">
              <div className="w-full flex items-center justify-between">
                <div className="text-sm sm:text-base text-[#0A0D13] font-medium">
                  Subtotal
                </div>
                <div className="text-sm sm:text-base text-[#0A0D13] font-medium">
                  RM 53.50
                </div>
              </div>
              <div className="w-full flex items-center justify-between">
                <div className="text-sm sm:text-base text-[#0A0D13] font-medium">
                  Add On Item
                </div>
                <div className="text-sm sm:text-base text-[#0A0D13] font-medium">
                  RM 40.00
                </div>
              </div>
            </div>
            <div className="w-full flex items-center">
              <div className="flex-1 text-base sm:text-lg text-[#112211] font-semibold">
                Total
              </div>
              <div className="text-lg sm:text-2xl md:text-[32px] md:leading-8 text-[#112211] font-semibold">
                RM 93.50
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={() => setPayNow(!payNow)}
          className="w-full h-[48px] px-4 py-3 bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white mb-6"
        >
          Pay Now
        </button>
        <div className="text-sm sm:text-base text-[#ACACAC] font-medium">
          Your personal data will be used to process your order, support your
          experience throughout this website, and for other purposes described
          in our privacy policy.
        </div>
      </div>
      <PaymentProcessModal open={payNow} setOpen={setPayNow} />
    </>
  );
}
export default Payment;
